import React from 'react'

const OnLoadedDomElement = ({ callback = () => {}, ...props }) => (
  <img src={''} onError={callback(props)} style={{ display: 'none' }} />
)

export default OnLoadedDomElement
